module.exports = __webpack_public_path__ + "static/media/airindia.600ec989.webp";